export default "__VITE_ASSET__DhjvNURH__"